import { useContext } from "react";
import { RelatorioProdutosContext } from "../context/RelatorioProdutosContext";
import { loadReportService } from "../services";

export default function ContainerFilters() {
    const { startDate, setStartDate, endDate, setEndDate, setReport } = useContext(RelatorioProdutosContext);

    const handleLoadReport = async () => {
        const response = await loadReportService(startDate, endDate);
        if (response) {
            setReport(response.data);
        }
    };

    return (
        <div className="flex flex-col sm:flex-row gap-4 mb-6">

            {/* Data Inicial */}
            <div className="flex flex-col w-full sm:max-w-[250px]">
                <label className="text-sm text-ink-3 mb-1">De</label>
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="h-[40px] bg-surface-2 border border-white/[0.08] px-3 py-2 rounded text-white w-full"
                />
            </div>

            {/* Data Final */}
            <div className="flex flex-col w-full sm:max-w-[250px]">
                <label className="text-sm text-ink-3 mb-1">Até</label>
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="h-[40px] bg-surface-2 border border-white/[0.08] px-3 py-2 rounded text-white w-full"
                />
            </div>

            {/* Buscar */}
            <div className="flex flex-col w-full sm:max-w-[250px]">
                <label>&nbsp;</label>
                <button
                    onClick={handleLoadReport}
                    className="h-[40px] bg-brand-600 hover:bg-brand-700 px-6 py-2 rounded w-full"
                >
                    Buscar
                </button>
            </div>

        </div>
    );
}
